export default function ErrorMessage({ message, children }) {
  const content = message || children;
  if (!content) return null;
  return (
    <p
      role="alert"
      style={{
        color: 'red',
        margin: 0,
        maxHeight: '8rem',
        overflow: 'auto',
        overflowWrap: 'anywhere',
      }}
    >
      {content}
    </p>
  );
}
